import React from 'react'
import type { Profile } from 'api/api.types'
import { Avatar } from 'components/Profile/Avatar/Avatar'
import { getFullName } from 'utils/getFullName'
import styles from './UserInfo.module.scss'

type UserInfoProps = {
  user: Profile | null,
}

export const UserInfo: React.FC<UserInfoProps> = (props) => {
  const { user } = props
  return (
    <div className={styles.userInfo}>
      <Avatar className={styles.avatar} user={user} />
      <div className={styles.name}>
        {getFullName(user)}
      </div>
      <div className={styles.email}>
        {user?.email ?? ''}
      </div>
    </div>
  )
}
